<script setup lang="ts" generic="T">
  import { type HeaderRenderProps } from "@krainovsd/vue-ui";
  import Eye from "@/components/icons/Eye.vue";

  type Settings = { onHide?: () => void };

  const props = defineProps<HeaderRenderProps<T, Settings>>();
</script>

<template>
  <div :class="$style.base">
    <span class="ksd-table__header-cell-default-text">
      {{ props.context.column.columnDef.name }}
    </span>
    <button
      type="button"
      :class="$style.eye"
      aria-label="hide"
      @click.stop="props.settings?.onHide?.()"
    >
      <Eye :size="14" />
    </button>
  </div>
</template>

<style lang="scss" module>
  .base {
    display: flex;
    align-items: center;
    gap: var(--ksd-padding, 4px);
  }

  .eye {
    flex-shrink: 0;
    padding: 2px;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    background: transparent;
    border: none;
    color: var(--muted-foreground);
    cursor: pointer;

    &:hover {
      color: var(--foreground);
    }
  }
</style>
